// Configuration d'authentification temporaire
// À remplacer par un système d'authentification complet dans une future version

export const AUTH_CONFIG = {
  // Mot de passe temporaire
  MASTER_PASSWORD: 'MasterPass',
  
  // Durée de validité de la session (en millisecondes)
  SESSION_DURATION: 24 * 60 * 60 * 1000, // 24 heures
  
  // Clés de stockage localStorage
  STORAGE_KEYS: {
    AUTHENTICATED: 'storm_authenticated',
    AUTH_TIMESTAMP: 'storm_auth_timestamp'
  },
  
  // Messages d'interface (maintenant gérés par i18n)
  // Les messages sont dans les fichiers de traduction : src/i18n/locales/
} as const;

// Fonction utilitaire pour vérifier l'authentification
export const isAuthenticated = (): boolean => {
  const isAuth = localStorage.getItem(AUTH_CONFIG.STORAGE_KEYS.AUTHENTICATED) === 'true';
  const authTimestamp = localStorage.getItem(AUTH_CONFIG.STORAGE_KEYS.AUTH_TIMESTAMP);
  
  if (!isAuth || !authTimestamp) {
    return false;
  }
  
  const now = Date.now();
  const authTime = parseInt(authTimestamp);
  
  return (now - authTime) < AUTH_CONFIG.SESSION_DURATION;
};

// Fonction utilitaire pour sauvegarder l'authentification
export const saveAuthentication = (): void => {
  localStorage.setItem(AUTH_CONFIG.STORAGE_KEYS.AUTHENTICATED, 'true');
  localStorage.setItem(AUTH_CONFIG.STORAGE_KEYS.AUTH_TIMESTAMP, Date.now().toString());
};

// Fonction utilitaire pour nettoyer l'authentification
export const clearAuthentication = (): void => {
  localStorage.removeItem(AUTH_CONFIG.STORAGE_KEYS.AUTHENTICATED);
  localStorage.removeItem(AUTH_CONFIG.STORAGE_KEYS.AUTH_TIMESTAMP);
};
